import TableHeading from '../../Components/common/table/Tableheading';
import TableData from '../../Components/common/table/TableData';
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { FaFilter } from "react-icons/fa";
import Filter from '../../Components/filter/Index';

const Index = () => {

   // for filter 
      const [filertVisible, setFilertVisible] = useState(false);

      const filterToggle = () =>{
        setFilertVisible(!filertVisible)
    }

    const [searchBtnClicked, setSearchBtnClicked ]=useState("");
    // const [showFields, setShowFields]=useState("");

    // filter field
    const [saralId, setSaralId] = useState("");
    const [contactNo, setContactNo] = useState("");
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const LIMIT = 50;
    const [page, setPage] = useState(1);
    const filters = `limit=${LIMIT}&page=${page}&saralId=${saralId}&contact=${contactNo}&startDate=${startDate}&endDate=${endDate}`; // new filter

  const [showInstallationSurveyList, setShowInstallationSurveyList]=useState([]);

  const fetchShowInstallationSurveyList = async ()=>{
      try {
          const response =await axios.get(`${process.env.REACT_APP_API_URL}/admin/showInstallationSurveyList?${filters}`);
          setShowInstallationSurveyList(response.data.data);

      } catch (error) {
          console.log("failed to fetch show installation survey list", error);
      }
  }

  useEffect(()=>{
      fetchShowInstallationSurveyList();
  }, [searchBtnClicked]);


 
  const key = [
    "fieldEmp","installationSurveyDate","saralId","farmerName","fatherOrHusbandName",
    "state","district","block",  "village","department", "caste","product","longitude","latitude", "LTDistance", "HP","AC_DC","depth","waterLevel","pumpHead",
    "sourceType","contact","consentLetter","consentWithFarmer","landDoc","challan","aadharFront","aadharBack","remark",
  ]
  const list = ['#', 'Survey Employee', 'Survey Date','Saral Id','Farmer Name', 'Father Name','State','District','Block','Village','Department', 'Caste',
    'Product', "Longitude", "Latitude", "LT_Distance", "HP", "AC_DC", "depth", "waterLevel","pumpHead",  "sourceType",'Contact Number', 'Consent Letter' ,
    'Consent With Farmer', 'LandDoc', 'Challan','Aadhar Front Page' ,'Aadhar Back Page', 'Remark' ]
  return (
    <>
        <button className='p-1 pl-5 pr-5 rounded-md absolute bottom-4 left-64 text-white bg-gray-800'>
            Back
        </button>
        <button className='p-1 pl-5 pr-5 rounded-md absolute bottom-4 right-16 text-white bg-gray-800' >
            Forward
        </button>
        <div className='overflow-auto h-[calc(100vh-8rem)]'>
            <div className="relative"></div>
              <table className=" text-gray-500 dark:text-gray-400" style={{ position: 'relative'}}>
                {/* Heading component */}
                <TableHeading
                    list={list}
                />
                <TableData keyList={key} dataList={showInstallationSurveyList}  />
              </table>
          </div>
          <button className='fixed bottom-24 right-12 bg-yellow-400 p-3 rounded-lg font-medium shadow-lg' onClick={filterToggle} ><FaFilter />
          </button>
          {filertVisible && 
         <Filter
            toggleState={setFilertVisible}
            contactNo={contactNo}
            setContactNo={setContactNo}
            setSaralId={setSaralId}
            saralId={saralId}
            searchBtn={searchBtnClicked}
            setSearchBtn={setSearchBtnClicked}
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            showFields={[true,true, false, false, true, true]}
         />}      
    </>
  )
}

export default Index;